/// <reference types="fhir" />

import { Component, Input } from "@angular/core";
import {
  Topic,
  TopicItem,
  itemEvaluationTopics,
  colorCodeSuggestionOptions,
  wrongColorReasonOptions,
  IDashboardItemEvaluation
} from "../../../../app/models/types";
import { Events } from "ionic-angular";
import { DiaprofilPatient } from "../../../../app/models/diaprofil-patient";
import { OnInit, OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";
import { FormBuilder, FormGroup, FormArray } from "@angular/forms";
import { v4 } from "uuid";
import { WidgetConfig } from "@zitelab/ionic-fhir-questionnaires/dist/models/widget";
import { Subscription } from "rxjs/Subscription";
import * as EvaluationActions from "../../../../app/store/actions/evaluation.actions";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app/models/app.state";
import { EvaluationState } from "../../../../app/store/reducers/evaluation.reducer";
import { take } from "rxjs/operators";
import { DiaprofilProTask } from "../../../../app/models/diaprofil-pro-task";
export function uuid(): string {
  return v4().replace(/-/g, "");
}

@Component({
  selector: "topic-evaluation-form",
  templateUrl: "./topic-evaluation-form.component.html"
})
export class TopicEvaluationForm implements OnInit, OnDestroy {
  @Input() topic: Topic;
  @Input() topicItems: TopicItem[];
  @Input() evaluationState: EvaluationState;
  @Input()
  displaySettings: {
    enableOtherHighlightedAnswers: boolean;
    showNoteInput: boolean;
    enableTrendDisplay: boolean;
  };
  @Input() patient: DiaprofilPatient;
  @Input() task: DiaprofilProTask;
  topicItemConfigs: WidgetConfig<any>[];
  topicItemOptions: {
    name: string;
    prefix: string;
    label: string;
    [name: string]: any;
  }[];
  evalForm: FormGroup = null;
  evalItems: FormArray;
  itemEvaluationTopics = itemEvaluationTopics;
  colorCodeSuggestionOptions = colorCodeSuggestionOptions;
  wrongColorReasonOptions = wrongColorReasonOptions;
  evalSubscription: Subscription;
  formChangesSubscription: Subscription;
  constructor(
    private formBuilder: FormBuilder,
    public store: Store<AppState>,
    public events: Events
  ) {
    this.events.subscribe("clear:itemEvals", params => {
      if (params.responseId === this.task.response.id) {
        const control = <FormArray>this.evalForm.controls.evalItems;
        control.value.map((item, index) => this.deleteItem(item, index));
      }
    });
  }

  createEvalItem(
    value = {
      id: uuid(),
      questionnaireResponseId: this.task.response.id,
      topicId: this.topic.id as string,
      questionnaireItemId: null,
      problemType: null,
      colorCodeIssueSuggestion: null,
      colorCodeIssueReason: null,
      issueText: null
    }
  ): FormGroup {
    return this.formBuilder.group(value);
  }

  addItem(): void {
    this.evalItems = this.evalForm.get("evalItems") as FormArray;
    this.evalItems.push(this.createEvalItem());
  }

  deleteItem($event, i: number): void {
    const control = <FormArray>this.evalForm.controls.evalItems;
    const item = control.value[i] as IDashboardItemEvaluation;
    this.store.dispatch(new EvaluationActions.DeleteAction({ id: item.id }));
    control.removeAt(i);
  }

  ngOnInit() {
    this.topicItemConfigs = this.topicItems.map(topicItem => topicItem.config);
    this.topicItemOptions = [
      { name: "WHOLE_TOPIC", prefix: null, label: "Hele området" },
      ...this.topicItemConfigs
    ];
    this.evalForm = this.formBuilder.group({
      evalItems: this.formBuilder.array([])
    });
    this.evalItems = this.evalForm.get("evalItems") as FormArray;
    this.formChangesSubscription = this.evalForm.valueChanges.subscribe(
      value => {
        const evalItems = value.evalItems as IDashboardItemEvaluation[];
        if (Array.isArray(evalItems)) {
          evalItems.map(item =>
            this.store.dispatch(
              new EvaluationActions.ReplaceAction({
                ...item,
                ...{
                  colorCodeIssueReason:
                    item.problemType === "ISSUE_WITH_COLOR_CODE"
                      ? item.colorCodeIssueReason
                      : null,
                  colorCodeIssueSuggestion:
                    item.problemType === "ISSUE_WITH_COLOR_CODE"
                      ? item.colorCodeIssueSuggestion
                      : null
                }
              })
            )
          );
        }
      }
    );
    this.evalSubscription = this.store
      .select(state => state.evaluation)
      .pipe(take(1))
      .subscribe(evalItems => {
        const relEvaluations = evalItems.filter(
          item =>
            item.topicId === this.topic.id &&
            item.questionnaireResponseId === this.task.response.id
        );
        relEvaluations.map(item => {
          this.evalItems = this.evalForm.get("evalItems") as FormArray;
          this.evalItems.push(this.createEvalItem(item));
        });
      });
  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-evaluation-form.component/topic-evaluation-form.component.ts